import { useAppState } from '@/overmind';

export function useShouldGridImageBeVisible() {
  const isTokenLoaded = useAppState().auth.current === 'AUTHENTICATED';
  const isCalculationTacticResultUnavailable =
    useAppState().calculation.isCalculationTacticResultUnavailable;

  return isTokenLoaded && isCalculationTacticResultUnavailable;
}
